import { CountryCode } from "../../../../Wrap/Constants/Enums/Domain/CountryCode";

export class CountryCodeMap {
    public static getString(countryCode: CountryCode): string {
        return this.getMap().get(countryCode);
    }

    public static getEnum(countryCode: string): CountryCode {
        const map = this.getMap();

        let result: CountryCode;

        map.forEach((value: string, index: CountryCode) => {
            if (value === countryCode) {
                result = index;
            }
        });

        return result;
    }

    public static getEnumByCountryCodeId(countryCode: number): CountryCode {
        const map = this.getMap();

        let result: CountryCode;

        map.forEach((value: string, index: CountryCode) => {
            if (index === countryCode) {
                result = index;
            }
        });

        return result;
    }

    public static getArray(defaultFirstCountryCode?: CountryCode): CountryCode[] {
        const options = [];
        options.push(CountryCode.GBR);
        options.push(CountryCode.ABW);
        options.push(CountryCode.AFG);
        options.push(CountryCode.AGO);
        options.push(CountryCode.AIA);
        options.push(CountryCode.ALA);
        options.push(CountryCode.ALB);
        options.push(CountryCode.AND);
        options.push(CountryCode.ARE);
        options.push(CountryCode.ARG);
        options.push(CountryCode.ARM);
        options.push(CountryCode.ASM);
        options.push(CountryCode.ATG);
        options.push(CountryCode.AUS);
        options.push(CountryCode.AUT);
        options.push(CountryCode.AZE);
        options.push(CountryCode.BDI);
        options.push(CountryCode.BEL);
        options.push(CountryCode.BEN);
        options.push(CountryCode.BES);
        options.push(CountryCode.BFA);
        options.push(CountryCode.BGD);
        options.push(CountryCode.BGR);
        options.push(CountryCode.BHR);
        options.push(CountryCode.BHS);
        options.push(CountryCode.BIH);
        options.push(CountryCode.BLM);
        options.push(CountryCode.BLR);
        options.push(CountryCode.BLZ);
        options.push(CountryCode.BMU);
        options.push(CountryCode.BOL);
        options.push(CountryCode.BRA);
        options.push(CountryCode.BRB);
        options.push(CountryCode.BRN);
        options.push(CountryCode.BTN);
        options.push(CountryCode.BWA);
        options.push(CountryCode.CAF);
        options.push(CountryCode.CAN);
        options.push(CountryCode.CCK);
        options.push(CountryCode.CHE);
        options.push(CountryCode.CHL);
        options.push(CountryCode.CHN);
        options.push(CountryCode.CIV);
        options.push(CountryCode.CMR);
        options.push(CountryCode.COD);
        options.push(CountryCode.COG);
        options.push(CountryCode.COK);
        options.push(CountryCode.COL);
        options.push(CountryCode.COM);
        options.push(CountryCode.CPV);
        options.push(CountryCode.CRI);
        options.push(CountryCode.CUB);
        options.push(CountryCode.CUW);
        options.push(CountryCode.CXR);
        options.push(CountryCode.CYM);
        options.push(CountryCode.CYP);
        options.push(CountryCode.CZE);
        options.push(CountryCode.DEU);
        options.push(CountryCode.DJI);
        options.push(CountryCode.DMA);
        options.push(CountryCode.DNK);
        options.push(CountryCode.DOM);
        options.push(CountryCode.DZA);
        options.push(CountryCode.ECU);
        options.push(CountryCode.EGY);
        options.push(CountryCode.ERI);
        options.push(CountryCode.ESH);
        options.push(CountryCode.ESP);
        options.push(CountryCode.EST);
        options.push(CountryCode.ETH);
        options.push(CountryCode.FIN);
        options.push(CountryCode.FJI);
        options.push(CountryCode.FLK);
        options.push(CountryCode.FRA);
        options.push(CountryCode.FRO);
        options.push(CountryCode.FSM);
        options.push(CountryCode.GAB);
        options.push(CountryCode.GEO);
        options.push(CountryCode.GGY);
        options.push(CountryCode.GHA);
        options.push(CountryCode.GIB);
        options.push(CountryCode.GIN);
        options.push(CountryCode.GLP);
        options.push(CountryCode.GMB);
        options.push(CountryCode.GNB);
        options.push(CountryCode.GNQ);
        options.push(CountryCode.GRC);
        options.push(CountryCode.GRD);
        options.push(CountryCode.GRL);
        options.push(CountryCode.GTM);
        options.push(CountryCode.GUF);
        options.push(CountryCode.GUM);
        options.push(CountryCode.GUY);
        options.push(CountryCode.HKG);
        options.push(CountryCode.HND);
        options.push(CountryCode.HRV);
        options.push(CountryCode.HTI);
        options.push(CountryCode.HUN);
        options.push(CountryCode.IDN);
        options.push(CountryCode.IMN);
        options.push(CountryCode.IND);
        options.push(CountryCode.IOT);
        options.push(CountryCode.IRL);
        options.push(CountryCode.IRN);
        options.push(CountryCode.IRQ);
        options.push(CountryCode.ISL);
        options.push(CountryCode.ISR);
        options.push(CountryCode.ITA);
        options.push(CountryCode.JAM);
        options.push(CountryCode.JEY);
        options.push(CountryCode.JOR);
        options.push(CountryCode.JPN);
        options.push(CountryCode.KAZ);
        options.push(CountryCode.KEN);
        options.push(CountryCode.KGZ);
        options.push(CountryCode.KHM);
        options.push(CountryCode.KIR);
        options.push(CountryCode.KNA);
        options.push(CountryCode.KOR);
        options.push(CountryCode.KWT);
        options.push(CountryCode.LAO);
        options.push(CountryCode.LBN);
        options.push(CountryCode.LBR);
        options.push(CountryCode.LBY);
        options.push(CountryCode.LCA);
        options.push(CountryCode.LIE);
        options.push(CountryCode.LKA);
        options.push(CountryCode.LSO);
        options.push(CountryCode.LTU);
        options.push(CountryCode.LUX);
        options.push(CountryCode.LVA);
        options.push(CountryCode.MAC);
        options.push(CountryCode.MAF);
        options.push(CountryCode.MAR);
        options.push(CountryCode.MCO);
        options.push(CountryCode.MDA);
        options.push(CountryCode.MDG);
        options.push(CountryCode.MDV);
        options.push(CountryCode.MEX);
        options.push(CountryCode.MHL);
        options.push(CountryCode.MKD);
        options.push(CountryCode.MLI);
        options.push(CountryCode.MLT);
        options.push(CountryCode.MMR);
        options.push(CountryCode.MNE);
        options.push(CountryCode.MNG);
        options.push(CountryCode.MNP);
        options.push(CountryCode.MOZ);
        options.push(CountryCode.MRT);
        options.push(CountryCode.MSR);
        options.push(CountryCode.MTQ);
        options.push(CountryCode.MUS);
        options.push(CountryCode.MWI);
        options.push(CountryCode.MYS);
        options.push(CountryCode.MYT);
        options.push(CountryCode.NAM);
        options.push(CountryCode.NCL);
        options.push(CountryCode.NER);
        options.push(CountryCode.NFK);
        options.push(CountryCode.NGA);
        options.push(CountryCode.NIC);
        options.push(CountryCode.NIU);
        options.push(CountryCode.NLD);
        options.push(CountryCode.NOR);
        options.push(CountryCode.NPL);
        options.push(CountryCode.NRU);
        options.push(CountryCode.NZL);
        options.push(CountryCode.OMN);
        options.push(CountryCode.PAK);
        options.push(CountryCode.PAN);
        options.push(CountryCode.PCN);
        options.push(CountryCode.PER);
        options.push(CountryCode.PHL);
        options.push(CountryCode.PLW);
        options.push(CountryCode.PNG);
        options.push(CountryCode.POL);
        options.push(CountryCode.PRI);
        options.push(CountryCode.PRK);
        options.push(CountryCode.PRT);
        options.push(CountryCode.PRY);
        options.push(CountryCode.PSE);
        options.push(CountryCode.PYF);
        options.push(CountryCode.QAT);
        options.push(CountryCode.REU);
        options.push(CountryCode.ROU);
        options.push(CountryCode.RUS);
        options.push(CountryCode.RWA);
        options.push(CountryCode.SAU);
        options.push(CountryCode.SDN);
        options.push(CountryCode.SEN);
        options.push(CountryCode.SGP);
        options.push(CountryCode.SGS);
        options.push(CountryCode.SHN);
        options.push(CountryCode.SLB);
        options.push(CountryCode.SLE);
        options.push(CountryCode.SLV);
        options.push(CountryCode.SMR);
        options.push(CountryCode.SOM);
        options.push(CountryCode.SPM);
        options.push(CountryCode.SRB);
        options.push(CountryCode.SSD);
        options.push(CountryCode.STP);
        options.push(CountryCode.SUR);
        options.push(CountryCode.SVK);
        options.push(CountryCode.SVN);
        options.push(CountryCode.SWE);
        options.push(CountryCode.SWZ);
        options.push(CountryCode.SXM);
        options.push(CountryCode.SYC);
        options.push(CountryCode.SYR);
        options.push(CountryCode.TCA);
        options.push(CountryCode.TCD);
        options.push(CountryCode.TGO);
        options.push(CountryCode.THA);
        options.push(CountryCode.TJK);
        options.push(CountryCode.TKL);
        options.push(CountryCode.TKM);
        options.push(CountryCode.TLS);
        options.push(CountryCode.TON);
        options.push(CountryCode.TTO);
        options.push(CountryCode.TUN);
        options.push(CountryCode.TUR);
        options.push(CountryCode.TUV);
        options.push(CountryCode.TWN);
        options.push(CountryCode.TZA);
        options.push(CountryCode.UGA);
        options.push(CountryCode.UKR);
        options.push(CountryCode.URY);
        options.push(CountryCode.USA);
        options.push(CountryCode.UZB);
        options.push(CountryCode.VAT);
        options.push(CountryCode.VCT);
        options.push(CountryCode.VEN);
        options.push(CountryCode.VGB);
        options.push(CountryCode.VIR);
        options.push(CountryCode.VNM);
        options.push(CountryCode.VUT);
        options.push(CountryCode.WLF);
        options.push(CountryCode.WSM);
        options.push(CountryCode.YEM);
        options.push(CountryCode.ZAF);
        options.push(CountryCode.ZMB);
        options.push(CountryCode.ZWE);

        options.push(CountryCode.ATA);
        options.push(CountryCode.BVT);
        options.push(CountryCode.ATF);
        options.push(CountryCode.HMD);
        options.push(CountryCode.SJM);
        options.push(CountryCode.UMI);
        const countryMap = this.getMap();
        options.sort((prev, next) => countryMap.get(prev).localeCompare(countryMap.get(next)));
        if(defaultFirstCountryCode){
            const defaultIndex=options.indexOf(defaultFirstCountryCode)
            options.splice(defaultIndex,1);
            let newOptionsWithDefault=[];
            newOptionsWithDefault.push(defaultFirstCountryCode);
            newOptionsWithDefault=newOptionsWithDefault.concat(options);
            return newOptionsWithDefault;
        }
        return options;
    }

    private static getMap(): Map<CountryCode, string> {
        const map = new Map<CountryCode, string>();

        map.set(CountryCode.NotSpecified, "Not Specified");
        map.set(CountryCode.ABW, "Aruba");
        map.set(CountryCode.AFG, "Afghanistan");
        map.set(CountryCode.AGO, "Angola");
        map.set(CountryCode.AIA, "Anguilla");
        map.set(CountryCode.ALA, "Aland Islands");
        map.set(CountryCode.ALB, "Albania");
        map.set(CountryCode.AND, "Andorra");
        map.set(CountryCode.ARE, "United Arab Emirates");
        map.set(CountryCode.ARG, "Argentina");
        map.set(CountryCode.ARM, "Armenia");
        map.set(CountryCode.ASM, "American Samoa");
        map.set(CountryCode.ATA, "Antarctica");
        map.set(CountryCode.ATF, "French Southern Territories");
        map.set(CountryCode.ATG, "Antigua and Barbuda");
        map.set(CountryCode.AUS, "Australia");
        map.set(CountryCode.AUT, "Austria");
        map.set(CountryCode.AZE, "Azerbaijan");
        map.set(CountryCode.BDI, "Burundi");
        map.set(CountryCode.BEL, "Belgium");
        map.set(CountryCode.BEN, "Benin");
        map.set(CountryCode.BES, "Bonaire (Sint Eustatius and Saba)");
        map.set(CountryCode.BFA, "Burkina Faso");
        map.set(CountryCode.BGD, "Bangladesh");
        map.set(CountryCode.BGR, "Bulgaria");
        map.set(CountryCode.BHR, "Bahrain");
        map.set(CountryCode.BHS, "Bahamas");
        map.set(CountryCode.BIH, "Bosnia and Herzegovina");
        map.set(CountryCode.BLM, "Saint Barthelemy");
        map.set(CountryCode.BLR, "Belarus");
        map.set(CountryCode.BLZ, "Belize");
        map.set(CountryCode.BMU, "Bermuda");
        map.set(CountryCode.BOL, "Bolivia");
        map.set(CountryCode.BRA, "Brazil");
        map.set(CountryCode.BRB, "Barbados");
        map.set(CountryCode.BRN, "Brunei");
        map.set(CountryCode.BTN, "Bhutan");
        map.set(CountryCode.BVT, "Bouvet Island");
        map.set(CountryCode.BWA, "Botswana");
        map.set(CountryCode.CAF, "Central African Republic");
        map.set(CountryCode.CAN, "Canada");
        map.set(CountryCode.CCK, "Cocos (Keeling) Islands");
        map.set(CountryCode.CHE, "Switzerland");
        map.set(CountryCode.CHL, "Chile");
        map.set(CountryCode.CHN, "China");
        map.set(CountryCode.CIV, "Cote d Ivoire");
        map.set(CountryCode.CMR, "Cameroon");
        map.set(CountryCode.COD, "Congo (Democratic Republic)");
        map.set(CountryCode.COG, "Congo");
        map.set(CountryCode.COK, "Cook Islands");
        map.set(CountryCode.COL, "Colombia");
        map.set(CountryCode.COM, "Comoros");
        map.set(CountryCode.CPV, "Cape Verde");
        map.set(CountryCode.CRI, "Costa Rica");
        map.set(CountryCode.CUB, "Cuba");
        map.set(CountryCode.CUW, "Curacao");
        map.set(CountryCode.CXR, "Christmas Island");
        map.set(CountryCode.CYM, "Cayman Islands");
        map.set(CountryCode.CYP, "Cyprus");
        map.set(CountryCode.CZE, "Czech Republic");
        map.set(CountryCode.DEU, "Germany");
        map.set(CountryCode.DJI, "Djibouti");
        map.set(CountryCode.DMA, "Dominica");
        map.set(CountryCode.DNK, "Denmark");
        map.set(CountryCode.DOM, "Dominican Republic");
        map.set(CountryCode.DZA, "Algeria");
        map.set(CountryCode.ECU, "Ecuador");
        map.set(CountryCode.EGY, "Egypt");
        map.set(CountryCode.ERI, "Eritrea");
        map.set(CountryCode.ESH, "Western Sahara");
        map.set(CountryCode.ESP, "Spain");
        map.set(CountryCode.EST, "Estonia");
        map.set(CountryCode.ETH, "Ethiopia");
        map.set(CountryCode.FIN, "Finland");
        map.set(CountryCode.FJI, "Fiji");
        map.set(CountryCode.FLK, "Falkland Islands");
        map.set(CountryCode.FRA, "France");
        map.set(CountryCode.FRO, "Faroe Islands");
        map.set(CountryCode.FSM, "Micronesia");
        map.set(CountryCode.GAB, "Gabon");
        map.set(CountryCode.GBR, "UK");
        map.set(CountryCode.GEO, "Georgia");
        map.set(CountryCode.GGY, "Guernsey");
        map.set(CountryCode.GHA, "Ghana");
        map.set(CountryCode.GIB, "Gibraltar");
        map.set(CountryCode.GIN, "Guinea");
        map.set(CountryCode.GLP, "Guadeloupe");
        map.set(CountryCode.GMB, "Gambia");
        map.set(CountryCode.GNB, "Guinea-Bissau");
        map.set(CountryCode.GNQ, "Equatorial Guinea");
        map.set(CountryCode.GRC, "Greece");
        map.set(CountryCode.GRD, "Grenada");
        map.set(CountryCode.GRL, "Greenland");
        map.set(CountryCode.GTM, "Guatemala");
        map.set(CountryCode.GUF, "French Guiana");
        map.set(CountryCode.GUM, "Guam");
        map.set(CountryCode.GUY, "Guyana");
        map.set(CountryCode.HKG, "Hong Kong");
        map.set(CountryCode.HMD, "Heard Island and McDonald Islands");
        map.set(CountryCode.HND, "Honduras");
        map.set(CountryCode.HRV, "Croatia");
        map.set(CountryCode.HTI, "Haiti");
        map.set(CountryCode.HUN, "Hungary");
        map.set(CountryCode.IDN, "Indonesia");
        map.set(CountryCode.IMN, "Isle of Man");
        map.set(CountryCode.IND, "India");
        map.set(CountryCode.IOT, "British Indian Ocean Territory");
        map.set(CountryCode.IRL, "Ireland");
        map.set(CountryCode.IRN, "Iran");
        map.set(CountryCode.IRQ, "Iraq");
        map.set(CountryCode.ISL, "Iceland");
        map.set(CountryCode.ISR, "Israel");
        map.set(CountryCode.ITA, "Italy");
        map.set(CountryCode.JAM, "Jamaica");
        map.set(CountryCode.JEY, "Jersey");
        map.set(CountryCode.JOR, "Jordan");
        map.set(CountryCode.JPN, "Japan");
        map.set(CountryCode.KAZ, "Kazakhstan");
        map.set(CountryCode.KEN, "Kenya");
        map.set(CountryCode.KGZ, "Kyrgyzstan");
        map.set(CountryCode.KHM, "Cambodia");
        map.set(CountryCode.KIR, "Kiribati");
        map.set(CountryCode.KNA, "Saint Kitts and Nevis");
        map.set(CountryCode.KOR, "South Korea");
        map.set(CountryCode.KWT, "Kuwait");
        map.set(CountryCode.LAO, "Laos");
        map.set(CountryCode.LBN, "Lebanon");
        map.set(CountryCode.LBR, "Liberia");
        map.set(CountryCode.LBY, "Libya");
        map.set(CountryCode.LCA, "Saint Lucia");
        map.set(CountryCode.LIE, "Liechtenstein");
        map.set(CountryCode.LKA, "Sri Lanka");
        map.set(CountryCode.LSO, "Lesotho");
        map.set(CountryCode.LTU, "Lithuania");
        map.set(CountryCode.LUX, "Luxembourg");
        map.set(CountryCode.LVA, "Latvia");
        map.set(CountryCode.MAC, "Macau");
        map.set(CountryCode.MAF, "Saint Martin (French part)");
        map.set(CountryCode.MAR, "Morocco");
        map.set(CountryCode.MCO, "Monaco");
        map.set(CountryCode.MDA, "Moldavia");
        map.set(CountryCode.MDG, "Madagascar");
        map.set(CountryCode.MDV, "Maldives");
        map.set(CountryCode.MEX, "Mexico");
        map.set(CountryCode.MHL, "Marshall Islands");
        map.set(CountryCode.MKD, "Macedonia");
        map.set(CountryCode.MLI, "Mali");
        map.set(CountryCode.MLT, "Malta");
        map.set(CountryCode.MMR, "Myanmar");
        map.set(CountryCode.MNE, "Montenegro");
        map.set(CountryCode.MNG, "Mongolia");
        map.set(CountryCode.MNP, "Northern Mariana Islands");
        map.set(CountryCode.MOZ, "Mozambique");
        map.set(CountryCode.MRT, "Mauritania");
        map.set(CountryCode.MSR, "Montserrat");
        map.set(CountryCode.MTQ, "Martinique");
        map.set(CountryCode.MUS, "Mauritius");
        map.set(CountryCode.MWI, "Malawi");
        map.set(CountryCode.MYS, "Malaysia");
        map.set(CountryCode.MYT, "Mayotte");
        map.set(CountryCode.NAM, "Namibia");
        map.set(CountryCode.NCL, "New Caledonia");
        map.set(CountryCode.NER, "Niger");
        map.set(CountryCode.NFK, "Norfolk Island");
        map.set(CountryCode.NGA, "Nigeria");
        map.set(CountryCode.NIC, "Nicaragua");
        map.set(CountryCode.NIU, "Niue");
        map.set(CountryCode.NLD, "Netherlands");
        map.set(CountryCode.NOR, "Norway");
        map.set(CountryCode.NPL, "Nepal");
        map.set(CountryCode.NRU, "Nauru");
        map.set(CountryCode.NZL, "New Zealand");
        map.set(CountryCode.OMN, "Oman");
        map.set(CountryCode.PAK, "Pakistan");
        map.set(CountryCode.PAN, "Panama");
        map.set(CountryCode.PCN, "Pitcairn");
        map.set(CountryCode.PER, "Peru");
        map.set(CountryCode.PHL, "Philippines");
        map.set(CountryCode.PLW, "Palau");
        map.set(CountryCode.PNG, "Papua New Guinea");
        map.set(CountryCode.POL, "Poland");
        map.set(CountryCode.PRI, "Puerto Rico");
        map.set(CountryCode.PRK, "North Korea");
        map.set(CountryCode.PRT, "Portugal");
        map.set(CountryCode.PRY, "Paraguay");
        map.set(CountryCode.PSE, "Palestine (State of)");
        map.set(CountryCode.PYF, "French Polynesia");
        map.set(CountryCode.QAT, "Qatar");
        map.set(CountryCode.REU, "Reunion");
        map.set(CountryCode.ROU, "Romania");
        map.set(CountryCode.RUS, "Russia");
        map.set(CountryCode.RWA, "Rwanda");
        map.set(CountryCode.SAU, "Saudi Arabia");
        map.set(CountryCode.SDN, "Sudan");
        map.set(CountryCode.SEN, "Senegal");
        map.set(CountryCode.SGP, "Singapore");
        map.set(CountryCode.SGS, "South Georgia and the South Sandwich Islands");
        map.set(CountryCode.SHN, "Saint Helena (Ascension and Tristan da Cunha)");
        map.set(CountryCode.SJM, "Svalbard and Jan Mayen");
        map.set(CountryCode.SLB, "Solomon Islands");
        map.set(CountryCode.SLE, "Sierra Leone");
        map.set(CountryCode.SLV, "El Salvador");
        map.set(CountryCode.SMR, "San Marino");
        map.set(CountryCode.SOM, "Somalia");
        map.set(CountryCode.SPM, "Saint Pierre and Miquelon");
        map.set(CountryCode.SRB, "Serbia");
        map.set(CountryCode.SSD, "South Sudan");
        map.set(CountryCode.STP, "Sao Tome and Principe");
        map.set(CountryCode.SUR, "Suriname");
        map.set(CountryCode.SVK, "Slovakia");
        map.set(CountryCode.SVN, "Slovenia");
        map.set(CountryCode.SWE, "Sweden");
        map.set(CountryCode.SWZ, "Swaziland");
        map.set(CountryCode.SXM, "Sint Maarten (Dutch part)");
        map.set(CountryCode.SYC, "Seychelles");
        map.set(CountryCode.SYR, "Syrian Arab Republic");
        map.set(CountryCode.TCA, "Turks and Caicos Islands");
        map.set(CountryCode.TCD, "Chad");
        map.set(CountryCode.TGO, "Togo");
        map.set(CountryCode.THA, "Thailand");
        map.set(CountryCode.TJK, "Tajikistan");
        map.set(CountryCode.TKL, "Tokelau");
        map.set(CountryCode.TKM, "Turkmenistan");
        map.set(CountryCode.TLS, "Timor-Leste");
        map.set(CountryCode.TON, "Tonga");
        map.set(CountryCode.TTO, "Trinidad and Tobago");
        map.set(CountryCode.TUN, "Tunisia");
        map.set(CountryCode.TUR, "Turkey");
        map.set(CountryCode.TUV, "Tuvalu");
        map.set(CountryCode.TWN, "Taiwan");
        map.set(CountryCode.TZA, "Tanzania");
        map.set(CountryCode.UGA, "Uganda");
        map.set(CountryCode.UKR, "Ukraine");
        map.set(CountryCode.UMI, "United States Minor Outlying Islands");
        map.set(CountryCode.URY, "Uruguay");
        map.set(CountryCode.USA, "USA");
        map.set(CountryCode.UZB, "Uzbekistan");
        map.set(CountryCode.VAT, "Holy See (Vatican City State)");
        map.set(CountryCode.VCT, "Saint Vincent and the Grenadines");
        map.set(CountryCode.VEN, "Venezuela");
        map.set(CountryCode.VGB, "Virgin Islands (British)");
        map.set(CountryCode.VIR, "Virgin Islands (USA)");
        map.set(CountryCode.VNM, "Vietnam");
        map.set(CountryCode.VUT, "Vanuatu");
        map.set(CountryCode.WLF, "Wallis and Futuna");
        map.set(CountryCode.WSM, "Samoa");
        map.set(CountryCode.YEM, "Yemen");
        map.set(CountryCode.ZAF, "South Africa");
        map.set(CountryCode.ZMB, "Zambia");
        map.set(CountryCode.ZWE, "Zimbabwe");

        return map;
    }
}
